import { Injectable } from '@angular/core';
import { Session } from 'src/app/interface/session/session';
import { SessionCode } from 'src/app/enums/session/session-code.enum';
import { SessionKey } from 'src/app/enums/session/session-key.enum';

@Injectable({
  providedIn: 'root'
})
export class LocaleSession implements Session
{
    constructor() { }

    get(): string | SessionCode
    {
        try{
            const locale = localStorage.getItem( SessionKey.LOCALE ) 
            return locale ? locale : SessionCode.MISSING_VALUE
        }catch(error)
        {
            return SessionCode.GENERIC
        }
    }

    set( locale : string ): SessionCode
    {
        if(!locale) return  SessionCode.INVALID_INPUT

        try{
            localStorage.setItem( SessionKey.LOCALE, locale ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }

    clear(): SessionCode
    {
        try{
            localStorage.removeItem( SessionKey.LOCALE ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }
}

